import { Button, Dialog, Heading, HStack, Portal, Text } from "@chakra-ui/react"
import type { ToastOptions } from "@pathwright/ux/src/components/chakra/ui/toaster"
import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"

// Shared with ToastSandbox so preview copy and confirmation stay in sync.
export const deployRefreshToastOptions: ToastOptions = {
  type: "info",
  title: "An updated version of Pathwright is available",
  duration: Infinity,
  closable: true
}

export function DeployRefreshConfirmation({
  open,
  onClose,
  onRefresh
}: {
  open: boolean
  onClose: () => void
  onRefresh: () => void
}) {
  const { t } = useTranslate()

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(details) => {
        if (!details.open) onClose()
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content maxWidth="420px" borderRadius="16px" p={6}>
            <Heading as="h2" size="md" m={0}>
              <Pathicon icon="rocket" boxSize="5" mr={2} />
              {t("Refresh to update Pathwright")}
            </Heading>
            <Text mt={3} mb={0}>
              {t("Complete any unsaved work before refreshing.")}
            </Text>
            <HStack gap={2} mt={5} justify="flex-end">
              <Button variant="ghost" onClick={() => onClose()}>
                {t("Keep working")}
              </Button>
              <Button colorPalette="blue" onClick={onRefresh}>
                {t("Refresh now")}
              </Button>
            </HStack>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
